export const KINDS = {
    Primary: 'primary',
    Secondary: 'secondary',
    Danger: 'danger',
    Ghost: 'ghost',
    InputLike: 'input-like',
};
export const STATES = {
    Disabled: 'disabled',
    Enabled: 'enabled',
    Loading: 'loading',
};
export const SIZES = {
    Small: 'small',
    Medium: 'medium',
    Big: 'big',
};
